// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2Je9V","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2GH5Q"};